import { render, staticRenderFns } from "./banner-selection.vue?vue&type=template&id=a56a0eee&scoped=true&"
var script = {}
import style0 from "./banner-selection.vue?vue&type=style&index=0&id=a56a0eee&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56a0eee",
  null
  
)

export default component.exports